import { render, staticRenderFns } from "./BlockName.vue?vue&type=template&id=df730d96&scoped=true&"
import script from "./BlockName.vue?vue&type=script&lang=js&"
export * from "./BlockName.vue?vue&type=script&lang=js&"
import style0 from "./BlockName.vue?vue&type=style&index=0&id=df730d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df730d96",
  null
  
)

export default component.exports